import { Component, Input } from '@angular/core';
import { TooltipDirective } from '@hs/ui-core-presentation';

@Component({
    selector: 'ddv-user-preference-labeled-row',
    templateUrl: './labeled-row.component.html',
    styleUrls: ['./labeled-row.component.scss'],
    imports: [TooltipDirective],
})
export class LabeledRowComponent {
    @Input() label: string | undefined;
    @Input() message: string | undefined;
}
